import {
    mapActions,
    mapGetters,
    mapMutations
} from 'vuex';
import FormCheck from '../Form/FormCheck/FormCheck.vue'

export default {

    components: {
        FormCheck
    },

    props: {},

    computed: {
        ...mapGetters([
            'groupements',
            'filtres',
            'tailles',
            'geometries',
            'materiaux',
            'bEtMs',
            'search',
            'searchLoading'
        ]),
    },

    data() {
        return {
            isFiltreTailleOpen: false,
            isFiltreGeoOpen: false,
            isFiltreBronzeOpen: false,
            isFiltreMatOpen: false,
            isFiltreThemeOpen: false,
            screenWidth: 1200,
        };
    },

    watch: {},

    methods: {
        ...mapActions(['getGroupements']),
        ...mapMutations(['resetFiltres']),

        filtre(obj, Objtype) {
            if (!this.searchLoading) {
                if (Objtype === 'geometries' || Objtype === 'bEtMs') {
                    obj.selected = !obj.selected
                }
                obj['type'] = Objtype;
                obj['libelle'] = obj['Libelle'];
                let index = this.filtres.findIndex((filtre) => filtre.type == obj.type && filtre.libelle == obj.libelle)
                if (index >= 0) {
                    this.filtres.splice(index, 1);
                }
                if (obj.selected) {
                    this.filtres.push(obj);
                }
                this.search.splice(0, this.search.length);
                this.$emit('filtre');
            }
        },

        resetCurrentFiltres() {
            let checkboxes = document.getElementsByTagName('input')
            for (let i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].type == 'checkbox') {
                    checkboxes[i].checked = false
                }
            }
            this.geometries.forEach(aGeo => {
                aGeo.selected = false
            })
            this.resetFiltres()
            this.$emit('filtre');
        },

        toggleSelected(pGeo) {
            if (!this.searchLoading) {
                pGeo.selected = true
            }
        },

        toggleAccordeon(pIndex) {
            if (pIndex === 0) {
                this.isFiltreTailleOpen = !this.isFiltreTailleOpen
            } else if (pIndex === 1) {
                this.isFiltreGeoOpen = !this.isFiltreGeoOpen
            } else if (pIndex === 2) {
                this.isFiltreBronzeOpen = !this.isFiltreBronzeOpen
            } else if (pIndex === 3) {
                this.isFiltreMatOpen = !this.isFiltreMatOpen
            } else if (pIndex === 4) {
                this.isFiltreThemeOpen = !this.isFiltreThemeOpen
            }
        }
    },

    mounted() {

        this.getGroupements().then(res => {
            // Rechercher des filtres déja selectionnées
            this.filtres.forEach(aFiltre => {
                if (aFiltre.selected) {
                    if (aFiltre.type === 'tailles') {
                        this.tailles.forEach(aTaille => {
                            if (aTaille.Libelle === aFiltre.libelle) {
                                aTaille.selected = true
                            }
                        })
                    }
                    if (aFiltre.type === 'geometries') {
                        this.geometries.forEach(aGeo => {
                            if (aGeo.Libelle === aFiltre.libelle) {
                                aGeo.selected = true
                            } else {
                                aGeo.selected = false
                            }
                        })
                    }
                    if (aFiltre.type === 'bEtMs') {
                        this.bEtMs.forEach(abEtM => {
                            if (abEtM.Libelle === aFiltre.libelle) {
                                abEtM.selected = true
                            }
                        })
                    }
                    if (aFiltre.type === 'materiaux') {
                        this.materiaux.forEach(aMat => {
                            if (aMat.Libelle === aFiltre.libelle) {
                                aMat.selected = true
                            }
                        })
                    }
                    if (aFiltre.type === 'groupements.THEME') {
                        this.groupements.THEME.forEach(aTheme => {
                            if (aTheme.Libelle === aFiltre.libelle) {
                                aTheme.selected = true
                            }
                        })
                    }
                }
            })

        }).catch(err => {
            console.log(err)
        })
        window.addEventListener("resize", (e) => this.screenWidth = window.innerWidth);
        this.screenWidth = window.innerWidth;
    },

};
